export default class RotatingButton {
    init() {
        window.onscroll = function () {
            scrollRotate();
        };
        
        function scrollRotate() {
            const button = document.querySelector(".Button--language");
            button.style.transform = "rotate(" + window.pageYOffset/2 + "deg)";
        }
    }
}


